import { render, staticRenderFns } from "./BattleGroups.vue?vue&type=template&id=75812bb2&scoped=true&"
import script from "./BattleGroups.vue?vue&type=script&lang=js&"
export * from "./BattleGroups.vue?vue&type=script&lang=js&"
import style0 from "./BattleGroups.vue?vue&type=style&index=0&id=75812bb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75812bb2",
  null
  
)

export default component.exports